import { render, staticRenderFns } from "./properties-index.vue?vue&type=template&id=70d1c47f"
import script from "./properties-index.vue?vue&type=script&lang=js"
export * from "./properties-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports